export class LockService {
    constructor($http) {
        this.http = $http;
    }

    getLockedUsers(page, limit) {
        return this.http.get(`/api/lock/${page}/${limit}`);
    }

    lockUser(params) {
        return this.http.post('/api/lock', params)
    }

    unlockUser(unlockUser) {
        return this.http.delete(`/api/lock/${unlockUser}`);
    }

    isBlocked(receiver, sender) {
        if (receiver && sender) {
            let params = {
                receiver: receiver,
                sender: sender
            };

            return this.http.post(`/api/lock/isblocked`, params);
        }
    }
}
